import Vue from 'vue'
import axios from 'axios'
import ViewUI from 'view-design'
import App from './App'
import store from './store'
import router from './router'
import 'view-design/dist/styles/iview.css'
import './permission'
import './style/global.css'


Vue.config.productionTip = false
Vue.use(ViewUI)
Vue.prototype.$axios = axios

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
})

window.addEventListener('unhandledrejection', (event) => {
    event.preventDefault()
    // 可选：记录到错误监控系统
    console.debug('静默处理的Promise拒绝:', event.reason)
})
